@if (totalPages > 1) {
  <!-- padinador que diga Mostrando [un input para seleccionar la página] de [total de items] "<"" paginas segun el total que hayan que sean clickeables, identificando la pagina activa ">" -->
  <div class="paginator-container">
    <span class="paginator-info"
      >Mostrando
      <form [formGroup]="form">
        <div class="select-wrapper">
          <select formControlName="page" class="select" formControlName="page">
            @for (item of rowsPerPageSelector(); track $index) {
              <option class="option" [value]="item">
                {{ item }}
              </option>
            }
          </select>
          <img
            class="select-icon"
            src="/icons/chevron-down.svg"
            alt="Arrow Down Icon"
          />
        </div>
      </form>
      de {{ totalItems }}</span
    >
    <div class="paginator-controls">
      <button
        class="paginator-button arrow-button"
        [disabled]="currentPage === 1"
        (click)="handlePageChange(currentPage - 1)"
      >
        <img src="/icons/chevron_left.svg" />
      </button>
      <!-- quiero que me muestre los números de página aquí -->
      @for (page of calculatePageNumbers(); track $index) {
        @if ($index === 1 && calculatePageNumbers()[0] === 1 && page != 2) {
          <span class="ellipsis">...</span>
        }
        @if ($index === 4 && page === totalPages) {
          <span class="ellipsis">...</span>
        }
        <button
          class="paginator-button"
          [class.active]="page === currentPage"
          (click)="handlePageChange(page)"
        >
          {{ page }}
        </button>
        @if ($index === 4 && page < totalPages - 1) {
          <span class="ellipsis">...</span>
        }
      }
      <button
        class="paginator-button arrow-button"
        [disabled]="currentPage === totalPages"
        (click)="handlePageChange(currentPage + 1)"
      >
        <img src="/icons/chevron_right.svg" />
      </button>
    </div>
  </div>
}
